import request from '../../axios';

const PostMachineryRequirement = async (
  payload: IMachineryRequirementPayload,
) => {
  const newPayload = {
    brs_type: payload.srs_type?.type,
    sub_input: payload.sub_input?.guid,
    title: payload.title,
    location: `POINT (${payload.location?.lng} ${payload.location?.lat})`,
    wanted_number: payload.wanted_number,
    request_date_unit: payload?.request_date_unit?.value,
    cultivation: payload.cultivation?.guid,
    only_massage_buyer: payload.only_massage_buyer || false,
    requirement_during: payload?.requirement_during,
    is_change_title: payload?.is_change_title,
    ad_price: payload.ad_price,
  };
  const res = await request.post(`api/v2/wanted/machinery-requirement`, {
    ...newPayload,
  });

  return res.data;
};

export default PostMachineryRequirement;
